<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-6 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/planned-maintenance/class-recommendation-and-notes"
          ></back-button>
          Update Class Recommendation And Note
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-6 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">
            <router-link
              :to="`/planned-maintenance/class-recommendation-and-notes`"
            >
              Class Recommendation And Notes</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <class-recommendation-and-note-form
              :form="form"
            ></class-recommendation-and-note-form>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";
import ClassRecommendationAndNoteForm from "./class-recommendation-and-note-form.vue";

export default {
  components: { ClassRecommendationAndNoteForm },
  name: "ClassRecommendationAndNoteUpdate",
  data() {
    return {
      form: {
        vessel_id: "",
      },

      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let form = await axios.get(
        `class_recommendation_and_notes/${this.$route.params.cranId}`
      );
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        await axios.patch(
          `class_recommendation_and_notes/${this.$route.params.cranId}`,
          this.form
        );
        // await this.handleFileUpload();
        this.isLoading = false;
        this.$router.push(
          "/planned-maintenance/class-recommendation-and-notes"
        );
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      this.isLoading = true;
      let attachment = this.$refs.file?.files[0];
      const id = this.form.id;
      let formData = new FormData();
      formData.append("id", id);
      formData.append("attachment", attachment);
      await axios
        .post("upload_class_recommendation_and_note_attachment", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
      if (this.career_request) {
        this.success = true;
        this.form = [];
      }
      this.isLoading = false;
    },
  },
};
</script>
